import React, { useState } from 'react';


const AddIAQSensorColumnPopupHOC = (Component:any) => 
function Comp(props:any){
    const [showAddSensorColumnPopup,setShowAddSensorColumnPopup] = useState<boolean>(false);

    const addSensorColumToggleHandler = () => {
        setShowAddSensorColumnPopup(!showAddSensorColumnPopup);
    }
	
	return <Component showAddSensorColumnPopup={showAddSensorColumnPopup} addSensorColumToggleHandler={addSensorColumToggleHandler} {...props}/>;
};

export default AddIAQSensorColumnPopupHOC;   